import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { Pill } from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import { Sort } from '../Filter';
import { AskAQuestion } from '../AskAQuestion/AskAQuestion.component';
import { PagerDisplayText } from '../PagerDisplayText/PagerDisplayText.component';
import { Header } from './component/Header';
import QAContext from '../../context/QAContext';
import { useQAResult } from './useQAResult';
import { dataModel } from '../dataModel';

const { number, bool } = proptypes;

export const QAResultHeader = ({ seoTotalResults = null, showHeader = true }) => {
  const {
    channel, dispatch, TotalResults, searchText, Results, seoAnswers
  } = useContext(QAContext);
  const qaResult = useQAResult();
  const isMobile = channel === 'mobile';

  if (!showHeader) return null;

  const noResults = !seoAnswers && (TotalResults === 0 || Results?.length === 0);

  const handleClearSearchPill = () => {
    dispatch({ action: 'SET_SEARCH_TEXT', value: '' });
  };

  return (
    isMobile
      ? (
        <>
          <div>
            <Header showTitleWithTotalQns seoData={seoTotalResults} />
          </div>
          {!qaResult && (
            <>
              <div className="sui-mr-4 sui-w-full">
                <PagerDisplayText />
              </div>
              {searchText && (
                <div className="sui-mb-4 sui-mt-2 sui-w-full">
                  <Pill
                    label={searchText}
                    onClick={handleClearSearchPill}
                    icon={<Close />}
                    data-testid="search-pill"
                  >
                    {Results?.length ? searchText : 'Clear search term'}
                  </Pill>
                </div>
              )}
              <div className="sui-mt-4 sui-w-full">
                <Sort />
              </div>
              {!noResults && <AskAQuestion />}
            </>
          )}
        </>
      )
      : (
        <>
          <div>
            <Header showTitleWithTotalQns seoData={seoTotalResults} />
          </div>
          {!qaResult && (
            <>
              <div className="sui-flex sui-justify-between sui-items-center sui-py-1 sui-mb-4">
                <PagerDisplayText />
                {searchText && (
                  <div className="sui-w-3/6">
                    <Pill
                      label={searchText}
                      onClick={handleClearSearchPill}
                      icon={<Close />}
                      clickable
                    >
                      {Results?.length ? searchText : 'Clear search term'}
                    </Pill>
                  </div>
                )}
                <Sort />
              </div>
              {!noResults && <AskAQuestion />}
            </>
          )}
        </>
      )
  );
};

QAResultHeader.displayName = 'QAResultHeader';

QAResultHeader.propTypes = {
  seoTotalResults: number,
  showHeader: bool
};

QAResultHeader.dataModel = dataModel;
